import { reactTableConstant } from "./constants";

const initialState = {
  filters: {},
};

export default function reducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case reactTableConstant.SET_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [payload.key]: payload.value,
        },
      };
    case reactTableConstant.RESET_FILTER:
      if (payload) {
        const updatedFilters = { ...state.filters };
        delete updatedFilters[payload];
        return {
          ...state,
          filters: updatedFilters,
        };
      }
      return {
        ...state,
        filters: {},
      };

    default:
      return state;
  }
}
